import React, { FC, ReactNode } from 'react'
import { ReactComponent as QuestionMarkCircleSvg } from 'src/assets/svg/question-mark-circle.svg'
import { ReactComponent as InfoCircleSvg } from 'src/assets/svg/ri-information-fill.svg'
import styles from './questionMarkTooltip.module.scss'
import { Tooltip } from '../Tooltip'

interface QuestionMarkTooltipProps {
  align?: any
  iconType?: 'question' | 'info'
  overlay: ReactNode
  overlayClassName?: string
  overlayInnerClassName?: string
  placement?: string
}

export const QuestionMarkTooltip: FC<QuestionMarkTooltipProps> = ({
  align,
  iconType = 'question',
  overlay,
  overlayClassName,
  overlayInnerClassName,
  placement,
}) => {
  const Icon = iconType === 'info' ? InfoCircleSvg : QuestionMarkCircleSvg
  const iconClassName =
    iconType === 'info' ? styles.infoIcon : styles.questionMarkTooltip

  return (
    <Tooltip
      align={align}
      overlay={overlay}
      overlayClassName={overlayClassName}
      overlayInnerClassName={overlayInnerClassName}
      placement={placement}
    >
      <Icon className={iconClassName} />
    </Tooltip>
  )
}
